import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTexts, selectConfig } from 'getaway-data-layer';

type props = {
  children: React.ReactElement;
};

const Data = ({ children }: props) => {
  const dispatch = useDispatch();
  const { apiBaseURL } = useSelector(selectConfig);

  // Child effects run before Setup's; an unset baseURL hits the page origin.
  useEffect(() => {
    if (apiBaseURL) {
      dispatch(getTexts());
    }
  }, [apiBaseURL]);

  return children;
};

export default Data;
